export const HERO_DEMO_SCENARIOS = [
  {
    id: 't4-ontario',
    chipLabel: 'T4 · Ontario payroll',
    release: '25D',
    question: 'How do I set up T4 reporting for Ontario employees?',
    retrieval: [
      {
        file: 'Payroll - Canada Tax Setup.pdf',
        score: 92,
        verified: true,
        preview: 'Legislative Reporting Units — provincial TRU mapping for Ontario T4 slip boxes and year-end statutory reporting.',
      },
      {
        file: 'Your implementation guide.pdf',
        score: 78,
        verified: true,
        preview: 'Tenant-specific payroll configuration: legal entity, TRU assignments, and element eligibility for ON employees.',
      },
      {
        file: 'T4 Statutory Reporting (25D).pdf',
        score: 71,
        verified: false,
        preview: '25D updates to statutory reporting flows and T4 box mapping validation rules.',
      },
    ],
    answer: [
      'Navigate to **Setup and Maintenance → Payroll → Statutory Reporting**.',
      'For Ontario employees, configure T4 slip box mappings under',
      '**Legislative Reporting Units**, then run the Year End Reports process.',
    ],
    sourceRef: 'F14233-04 · tenant: acme_payroll_cfg.pdf',
  },
  {
    id: 'absence-plans',
    chipLabel: 'Absence plans',
    release: '25D',
    question: 'How do I set up absence plans in Oracle HCM?',
    retrieval: [
      {
        file: 'Absence Management Guide.pdf',
        score: 95,
        verified: true,
        preview: 'Absence plan types, eligibility profiles, and accrual method configuration for enterprise deployments.',
      },
      {
        file: 'HR Core Configuration.pdf',
        score: 82,
        verified: true,
        preview: 'Workforce structure prerequisites: legal employer, department trees, and person types for absence eligibility.',
      },
      {
        file: 'Leave Policy Setup (25D).pdf',
        score: 68,
        verified: false,
        preview: '25D changes to absence plan carryover rules and compensatory time handling.',
      },
    ],
    answer: [
      'Navigate to **Setup and Maintenance → Absence Management → Absence Plans**.',
      'Click **Create** and configure plan type, eligibility rules,',
      'accrual frequency and carryover limits.',
    ],
    sourceRef: 'F22851-02 · tenant: acme_hr_core.pdf',
  },
  {
    id: 'payroll-25d',
    chipLabel: '25D payroll updates',
    release: '25D',
    question: 'What changed in Oracle HCM 25D for payroll?',
    retrieval: [
      {
        file: 'Oracle HCM 25D Release Notes.pdf',
        score: 97,
        verified: true,
        preview: 'Official 25D payroll feature list: retro pay, compliance updates, and element entry enhancements.',
      },
      {
        file: 'Payroll Compliance Updates.pdf',
        score: 85,
        verified: true,
        preview: 'Statutory compliance changes for CA, UK, and India payroll processing in 25D.',
      },
      {
        file: 'Statutory Reporting Changes.pdf',
        score: 74,
        verified: false,
        preview: 'Quarterly statutory reporting adjustments and new validation messages for year-end.',
      },
    ],
    answer: [
      'Key **Oracle HCM 25D** payroll updates:',
      '• Enhanced **retroactive pay** processing rules',
      '• Updated **statutory compliance** for CA, UK, India',
    ],
    sourceRef: '25D Release Notes · shared: oracle_hcm_langchain',
  },
];

/** Strip hero-only fields for AnimatedChatDemo detailed mode */
export function toDetailedDemoShape(scenario) {
  return {
    question: scenario.question,
    retrieval: scenario.retrieval.map(({ file, score, verified }) => ({ file, score, verified })),
    answer: scenario.answer,
  };
}

export const DETAILED_DEMOS = HERO_DEMO_SCENARIOS.map(toDetailedDemoShape);
